"use strict";

angular.module("vendor")
.controller("SectionLogin", function(
    $scope, $state, $rootScope, $stateParams, $http, FlashBag, gettextCatalog, UserService, GroupService, QUICKBOOKS
) {
    $scope.isQuickBooksGuide = $stateParams.qbo_guide || false;
    $scope.QuickBooksGuideURL = QUICKBOOKS.INTEGRATION_GUIDE_URL;

    $scope.$on("UserUpdated", function() {
        if (UserService.isLoggedIn()) {
            if ($stateParams.state) {
                var state = $stateParams.state;
                var params = {};

                if (state === "orderDetails") {
                    params["id"] = $stateParams.order;
                    if ($stateParams.referer) {
                        params["referer"] = $stateParams.referer;
                    }
                }

                $state.go(state, params);
            }
            else if ($stateParams.groupInvite) {
                GroupService.addVendorGroupMembershipFromLogin($stateParams.groupInvite);
            }
            else if ($scope.isQuickBooksGuide) {
                $state.go("company-edit", {qbo_guide: 1});
            }
            else {
                $state.go("home");
            }
        }
    });

    $scope.$on("ImpersonatorUserUpdated", function() {
        if (UserService.isLoggedIn()) {
            $state.go("supportVendorList");
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/auth/login.controller.js
// module id = 975
// module chunks = 0